// projectDetials.js

import { CLIENT_DETAILS_FAILURE, CLIENT_DETAILS_REQUEST, CLIENT_DETAILS_SUCCESS, } from "../Actions/Actions";


const initialState = {
  isLoading: false,
  client: [],
  error: null,
};

const clientDetailsReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case CLIENT_DETAILS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case CLIENT_DETAILS_SUCCESS:
      return { ...state, isLoading: false, client: payload };
    case CLIENT_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default clientDetailsReducer;
